<template>
  <div v-if="path" class="row">
    <!-- fluidSelectRow -->

    <div v-if="noLabel === false" class="col-4">
      <label class="label-unidato geometrySelectLabel">{{ uniTranslation("S572") }}</label>
    </div>
    <div v-if="noLabel === false" class="col-8">
      <el-select
        v-model="selectedPressure"
        class="geometrySelect"
        placeholder="..."
        filterable
        :disabled="bOneItem"
      >
        <el-option
          v-for="item in pressuresList"
          :key="item.idPressione"
          :label="uniTranslation(item.descrizione)"
          :value="item.press_GUID"
        ></el-option>
      </el-select>
    </div>
    <div v-if="noLabel === true" class="col-12">
      <el-select
        v-model="selectedPressure"
        placeholder="..."
        filterable
        class="geometrySelect"
        :disabled="bOneItem"
      >
        <el-option
          v-for="item in pressuresList"
          :key="item.idPressione"
          :label="uniTranslation(item.descrizione)"
          :value="item.press_GUID"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Select, Option } from "element-ui";
import { Notification } from "element-ui";

export default {
  name: "PhePressurePicker",
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    projectPath: {
      type: String,
      required: true
    },
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    },
    noLabel: Boolean
  },
  data() {
    return {
      pressuresList: [],
      selectedPressure: "",
      path: "",
      unsubscribes: [],
      bOneItem: false
    };
  },
  computed: {
    ...mapGetters("_translationModule", ["currentLanguage", "languages"]),
    ...mapGetters("_prjModule", ["isSaldobrasata", "projects", "isVerifica"]),
    ...mapGetters("_pressuresModule", ["avaiablePress"])
  },
  mounted: function() {
    var that = this;

    if (that.parentPath && that.localPath) that.path = that.parentPath + that.localPath;

    that.setPressuresSelection();
  },
  watch: {
    isVerifica: function() {
      var that = this;
      if (this.isVerifica) {
        that.setPressuresVerify();
      } else {
        that.setPressuresSelection();
      }
    },
    avaiablePress: function() {
      var that = this;
      if (this.isVerifica) {
        that.pressuresList = that.avaiablePress;
      }
      that.setSelectedPressure();
    },
    selectedPressure: function() {
      this.setSelectedPressure();
    }
  },
  methods: {
    ...mapActions("_pressuresModule", ["getPressuresListByModAction"]),
    ...mapActions("_prjModule", ["changeProperty"]),
    setSelectedPressure() {
      var that = this;

      var index = 0;
      that.pressuresList.forEach((pressure, i) => {
        if (pressure.press_GUID == that.selectedPressure) {
          index = i;
        }
      });
      that.selectedPressure = that.pressuresList[index].press_GUID;

      if (that.pressuresList.length == 1) {
        that.bOneItem = true;
      } else {
        that.bOneItem = false;
      }

      that.changeProperty({
        path: that.path,
        value: that.selectedPressure
      });
    },
    setPressuresVerify() {
      var that = this;
      that.pressuresList = that.avaiablePress;
    },
    setPressuresSelection() {
      var that = this;

      var payload = {};
      var prj = that.projects[that.projectPath];

      payload.mod = prj.modality;
      payload.isSaldobrasata = that.isSaldobrasata;

      that.getPressuresListByModAction(payload).then(data => {
        if (data) {
          that.pressuresList = data;
          if (that.pressuresList.length > 0) {
            that.setSelectedPressure();
          }
        }
      });
    }
  }
};
</script>

<style lang="scss">
.geometrySelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.geometrySelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}

.geometrySelectRow {
  margin-right: 0px;
  margin-left: 0px;
  .col-3 {
    padding-right: 0px;
    padding-left: 0px;
  }
  .col-9 {
    padding-right: 0px;
    padding-left: 0px;
  }
}
</style>
